/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import PropTypes from 'prop-types';

const iconPropTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export { iconPropTypes as i };
